jQuery(($) => {
	/****************** LOCATION ******************/

	$(".location-images .icon-column").on(
		"click",
		".icon-embedded",
		function () {
			$(".location-images > *").removeClass("active");
			$(".location-images .icon-column .icon-embedded").removeClass(
				"active"
			);
			$(this).addClass("active");

			const selectedClass = $(this)
				.attr("class")
				.split(" ")[1]
				.split("-")[1];
			$(`.location-images .embedded-${selectedClass}`).addClass("active");
		}
	);
});
